import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import { 
  STR_CONTACT_US 
} from "../Strings";
import { MdCall, MdEmail, MdDirectionsBike, MdPerson, MdPhone, MdDirectionsCar } from 'react-icons/md';
import { FaWhatsapp } from "react-icons/fa";
import MobileInterface from "../MobileInterface";
import { getInlineLoader } from "../Helpers";

export default function RiderRegistration(props) {
  const appContext = useContext(AppContext);

  /* States */
  const [ready, setReady] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [formData, setFormData] = useState({
    fullName: "",
    phoneNumber: "",
    vehicleType: "Boda",
    city: ""
  });

  async function init() {
    setReady(false);
    // Simulation of loading
    setTimeout(() => {
      setReady(true);
    }, 500);
  }

  useEffect(() => {
    init();
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitting(true);
    
    // Dummy API call simulation
    setTimeout(() => {
      alert("Application sent successfully!");
      setSubmitting(false);
    }, 1500);
  };

  if (ready) {
    return (
      <div
        style={{
          width: "100%",
          height: "100%",
          overflowY: "auto",
          backgroundColor: "#fcfcfc"
        }}
        className="mNoScrollBar"
      >
        <div className="container py-4">
          <div className="row justify-content-center">
            <div className="col-md-11 col-lg-8">
              
              {/* Header Section */}
              <div className="mb-4 text-center">
                <MdDirectionsBike size={48} style={{ color: "var(--primaryColor)" }} />
                <h3 className="font-bold mt-2" style={{ color: "var(--primaryColor)", letterSpacing: "-0.5px" }}>
                  Request to Become a Rider 
                </h3>
                <p className="text-muted">Fill in your details and we'll get back to you.</p>
              </div>

              {/* Dummy Form */}
              <div className="card shadow-sm border-0 p-4" style={{ borderRadius: "15px" }}>
                <form onSubmit={handleSubmit}>
                  
                  {/* Full Name */}
                  <div className="mb-3">
                    <label className="form-label small font-bold">Full Name</label>
                    <div className="input-group">
                      <span className="input-group-text bg-white border-end-0"><MdPerson color="#888" /></span>
                      <input 
                        type="text" 
                        name="fullName"
                        className="form-control border-start-0 ps-0 shadow-none" 
                        placeholder=""
                        value={formData.fullName}
                        onChange={handleInputChange}
                        required 
                      />
                    </div>
                  </div>

                  {/* Phone Number */}
                  <div className="mb-3">
                    <label className="form-label small font-bold">Phone Number</label>
                    <div className="input-group">
                      <span className="input-group-text bg-white border-end-0"><MdPhone color="#888" /></span>
                      <input 
                        type="tel" 
                        name="phoneNumber"
                        className="form-control border-start-0 ps-0 shadow-none" 
                        placeholder=""
                        value={formData.phoneNumber}
                        onChange={handleInputChange}
                        required 
                      />
                    </div>
                  </div>

                  {/* Vehicle Type */}
                  <div className="mb-4">
                    <label className="form-label small font-bold">Vehicle Type</label>
                    <div className="input-group">
                      <span className="input-group-text bg-white border-end-0"><MdDirectionsCar color="#888" /></span>
                      <select 
                        name="vehicleType"
                        className="form-select border-start-0 ps-0 shadow-none"
                        value={formData.vehicleType}
                        onChange={handleInputChange}
                      >
                        <option value="Motorcycle">Motorcycle</option>
                        <option value="Car">Car</option>
                        <option value="Bajaji">Bajaji</option>
                      </select>
                    </div>
                  </div>

                  {/* Submit Button */}
                  <button 
                    type="submit" 
                    className="btn w-100 py-3 font-bold" 
                    disabled={submitting}
                    style={{ 
                      backgroundColor: "var(--primaryColor)", 
                      color: "#fff",
                      borderRadius: "10px",
                      transition: "0.3s"
                    }}
                  >
                    {submitting ? "Sending..." : "Submit Application"}
                  </button>

                </form>
              </div>

              {/* Footer Help */}
              <div className="mt-5 text-center">
                <p className="small text-muted mb-2">Need help? Contact us via</p>
                <div className="d-flex justify-content-center gap-3">
                  <FaWhatsapp size={24} color="#25D366" style={{ cursor: "pointer" }} />
                  <MdCall size={24} color="var(--primaryColor)" style={{ cursor: "pointer" }} />
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    );
  } else {
    return (
      <div
        className="mSupportLoading"
        style={{
          width: "100%",
          height: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        }}
      >
        {getInlineLoader()}
      </div>
    );
  }
}